import React, { useEffect, useRef, useState } from "react";
import { RiBarChartHorizontalLine } from "react-icons/ri";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { FiSun } from "react-icons/fi";
import { MdOutlineDarkMode } from "react-icons/md";
import avatar from "../../assets/avatar.png";
import logoDark from "../../assets/icon/logo-lite.png";
import logoLight from "../../assets/icon/logo-lite.png";
import Popover from "../Popover";
import AvatarDropdownMenu from "./avatarDropdownMenu";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { useClickOutside } from "../../hooks/useClickOutside";
import {
  getLocalStorage,
  removeLocalStorage,
} from "../../utils/function/localStorage";
import { useGetLoginUserQuery } from "../../Services/userApi";

import LanguageMenu from "./languageMenu";
import cookie from "js-cookie";
import { IoIosMenu } from "react-icons/io";
const Header = ({ show, setShow }) => {
  // avater clckable menu
  const profileRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  useClickOutside(profileRef, () => setOpenMenu(false));
  // mobile show menu
  const [showMenu, setShowMenu] = useState(false);
  getLocalStorage("dark-mode");
  const [value, setValue] = useLocalStorage("dark-mode", "light");
  const handleThemeMode = () => {
    if (value === "dark") {
      setValue("light");
    } else {
      setValue("dark");
    }
  };

  // language menu
  // Language Popover
  const langRef = useRef(null);
  const [openLang, setOpenLang] = useState(false);
  useClickOutside(langRef, () => setOpenLang(false));
  const currentLanguage = cookie.get("i18next");
  const languages = [
    {
      code: "en",
      name: "English",
      country: "United States",
      flagCode: "us",
    },

    {
      code: "ur",
      name: "Urdu",
      country: "Pakistan",
      flagCode: "pk",
    },
  ];
  // console.log({ languages });
  // console.log({ currentLanguage });
  const findLang = languages.find((d) => d.code === currentLanguage);
  console.log({ findLang });
  useEffect(() => {
    if (value === "dark") {
      document.body.classList.add("dark");
      document.body.classList.remove("light");
    } else {
      document.body.classList.remove("dark");
      document.body.classList.add("light");
    }
  }, [value]);
  // handle logout
  const handleLogout = () => {
    removeLocalStorage("grow_boo_token");
    window.location.reload();
  };
  // get user
  const { data } = useGetLoginUserQuery();
  console.log({ languages });
  return (
    <div className="ss-trade_header_wrapper">
      <div className="container">
        <div className="ss-trade_header_container">
          <div className="ss-trade_hamburger">
            {value === "dark" ? (
              <img
                src={logoDark}
                width="100%"
                className="ss-trade_loog"
                alt="logo"
              />
            ) : (
              <img
                src={logoLight}
                width="100%"
                className="ss-trade_loog"
                alt="logo"
              />
            )}

            <IoIosMenu
              className="hamburger_icon"
              onClick={() => setShow(!show)}
              color="red"
            />
          </div>
          <div className="verticalDots">
            <button type="button" onClick={() => setShowMenu(!showMenu)}>
              <BiDotsVerticalRounded />
            </button>
          </div>
          <div
            className={`ss-trade_header_menu ${showMenu ? "active_show" : ""}`}
          >
            <ul className="ss-trade_header_menu_lists">
              <li className="ss-trade_header_menu_list">
                {/* Language Popover */}
                {data?.data?.role !== "admin" && (
                  <li ref={langRef} className="ss-trade_header_menu_list">
                    <div className="msg_icon theme_icon" id="theme_icon">
                      <button
                        onClick={() => setOpenLang(!openLang)}
                        id="theme_icon"
                      >
                        {findLang.name === "English" ? (
                          <img
                            src="https://flagcdn.com/w40/us.png"
                            alt="English"
                          />
                        ) : (
                          <img
                            src="https://flagcdn.com/w40/pk.png"
                            alt="Pakisthan"
                          />
                        )}
                      </button>
                    </div>
                    <Popover
                      openPopover={openLang}
                      className="clickable_submenu"
                      style={{ width: "150px" }}
                    >
                      <LanguageMenu
                        setOpenLang={setOpenLang}
                        languages={languages}
                        findLang={findLang}
                      />
                    </Popover>
                  </li>
                )}
              </li>
              <li className="ss-trade_header_menu_list">
                <div className="msg_icon theme_icon" id="theme_icon">
                  <button onClick={handleThemeMode} id="theme_icon">
                    {value === "dark" ? <FiSun /> : <MdOutlineDarkMode />}
                  </button>
                </div>
              </li>

              <li ref={profileRef} className="ss-trade_header_menu_list">
                <img
                  src={data?.data?.avatar ? data?.data?.avatar : avatar}
                  alt="user_pic"
                  onClick={() => setOpenMenu(!openMenu)}
                />
                <Popover openPopover={openMenu} className="clickable_submenu">
                  <AvatarDropdownMenu
                    setOpenMenu={setOpenMenu}
                    logout={handleLogout}
                    data={data?.data}
                  />
                </Popover>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
